<template>
  <div>
    <p class="sw-intro">
      {{ t('Añada al resto de personas o empresas que intervienen (por ejemplo, el vendedor o los demás herederos). Basta con el nombre, el documento y su papel; la notaría contactará con ellos. Si aún no los conoce, puede continuar sin añadir a nadie.') }}
    </p>

    <div v-for="(p, i) in estado.intervinientes" :key="p.uid" class="sw-tarjeta">
      <div class="sw-tarjeta__cabecera">
        <span class="sw-subtitulo">{{ t('Interviniente {n}', { n: i + 2 }) }}</span>
        <v-btn variant="text" size="small" prepend-icon="mdi-close" @click="quitarInterviniente(p.uid)">{{ t('Quitar') }}</v-btn>
      </div>
      <SolicitudPersonaCampos :persona="p" :prefijo="`intervinientes.${i}`" :roles="tipo?.roles ?? []" />
    </div>

    <v-btn variant="outlined" class="sw-anadir" prepend-icon="mdi-plus" @click="anadirInterviniente">
      {{ t('Añadir interviniente') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { t } from '../../composables/solicitudTextos'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
const { estado, tipo, anadirInterviniente, quitarInterviniente } = useSolicitudWeb()
</script>
